export default "__VITE_ASSET__C6NqFey6__"